<template>
  <div>
    <div
        class="scroll_container"
        style="padding-bottom: 30px"
    >
      <table class="table">
        <thead>
          <tr>
            <th
              v-for="item in headItems"
              :key="item.key"
            >
              {{ $t(item.name) }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in bodyItems"
            :key="item.key"
            :class="{ error: item.id_onesignal == 'error' }"
          >
            <td v-if="step == 1">{{ item.notify_id }}</td>
            <td v-else>{{ item.push_id }}</td>

            <!--            <td>-->
<!--              {{ item.date_send }}-->
<!--            </td>-->
            <td v-if="step === 1">
              {{ item.name }}
            </td>
            <td v-if="step === 2">{{ JSON.parse(item.text_list).headings }}</td>
            <td v-if="step === 2">{{ JSON.parse(item.text_list).contents }}</td>
            <td
              style="width: 100px"
              v-if="step === 1 || step === 2"
            >
              <div
                class="all__geo"
                @click="watchGeo(item.notify_geo, item.notify_id, item.push_ref_id, JSON.parse(item.text_list).contents)"
              >
                <img src="../../assets/images/info.svg">
              </div>
            </td>
            <td v-if="step === 3">
              {{ item.geo }}
            </td>
            <td v-if="step === 4">
              {{ item.app.name }}
            </td>
            <td>{{ item.total_sum }}</td>
            <td>{{ item.total_sum - item.failed_sum }}</td>
            <td>{{ item.failed_sum }}</td>
            <td>{{ item.converted_sum }}</td>
            <td>{{ (item.total_sum - item.failed_sum) != 0 ? ((item.converted_sum / (item.total_sum - item.failed_sum)) * 100).toFixed(3) : "0"  }}</td>
            <td>{{ item.registrations_sum }}</td>
            <td>{{ item.converted_sum != 0 ? ((item.registrations_sum / item.converted_sum) * 100).toFixed(3) : "0" }}</td>
            <td>{{ item.first_deposits_sum }}</td>
            <td>{{ item.converted_sum != 0 ? ((item.first_deposits_sum / item.converted_sum) * 100).toFixed(3) : "0"  }}</td>
            <td>{{ item.deposits_sum }}</td>
            <td>{{ item.repeated_deposits_sum }}</td>
            <td v-if="step === 1">
              <div
                class="next__step"
                @click="goToStep(item)"
              >
                пуши
                <img src="../../assets/images/double_arrow.svg">
              </div>
            </td>
            <td v-if="step === 3">
              <div
                class="next__step"
                @click="goToApps(item.geo)"
              >
                к прилам
                <img src="../../assets/images/double_arrow.svg">
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot v-if="totalItems">
          <tr>
            <td>Total</td>
            <td v-if="step === 2"></td>
            <td v-if="step === 1 || step === 2"></td>
            <td></td>
            <td>{{ totalItems.total }}</td>
            <td>{{ totalItems.total - totalItems.failed }}</td>
            <td>{{ totalItems.errored }}</td>
            <td>{{ totalItems.converted }}</td>
            <td>{{ totalItems.converted != 0 ? ((totalItems.converted / (totalItems.total - totalItems.failed))*100).toFixed(3) : "0" }}</td>
            <td>{{ totalItems.registrations }}</td>
            <td>{{ totalItems.registrations != 0 ? ((totalItems.registrations / totalItems.converted) * 100).toFixed(3) : "0" }}</td>
            <td>{{ totalItems.first_deposits }}</td>
            <td>{{ totalItems.first_deposits != 0 ?  ((totalItems.first_deposits / totalItems.converted) * 100).toFixed(3) : "0" }}</td>
            <td>{{ totalItems.deposits_sum }}</td>
            <td>{{ totalItems.repeated_deposits }}</td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: `TableCustom`,
  props: ["headItems", "bodyItems", "step", "dateTo", "dateFrom", "totalItems"],
  data() {
    return {
      cntDay: 0,
    };
  },
  created() {
    console.log('ok', this.bodyItems)
    this.cntDay = this.dateTo - this.dateFrom + 1;
  },
  methods: {
    watchGeo(geo, id, sendId, itemText) {
      this.$emit("watchGeo", geo, id, sendId, itemText);
    },
    goToApps(itemGeo) {
      this.$emit("goToApps", itemGeo);
      localStorage.setItem('geoItem', itemGeo);
    },
    goToStep(itemId, itemName) {
      this.$emit("goToStep", itemId.notify_id);
      localStorage.setItem('companyName', JSON.parse(itemId.text_list).headings);
    },
  },
};
</script>

<style scoped lang="scss">
.next__step {
  white-space: nowrap;
  img {
    position: relative;
    top: 3.5px;
  }
}

tfoot {
  position: relative;

  tr {
    height: 50px;
    padding-bottom: 20px;
    background-color: #242424;

    td {
      color: white;
      font-family: HalvarR;
      text-align: center;
    }
  }
  &:before {
    content: " ";
    top: 0;
    left: 0;
    width: 100%;
    position: absolute;
    border-radius: 8px;
    background: linear-gradient(90deg, #ff6700, #ff2a00, #830be2, #00f);
    padding: 1px;
  }
}
</style>
